import React from 'react'

export const defaultInterfaceContext = {
  isDesktopViewport: null,
  projectImageFeatured: null,
  featureProjectImage: () => {},
  currentProjectImages: [],
  setCurrentProjectImages: () => {},
  projectImagesBrowserStatus: 'initial',
  toggleProjectImagesBrowser: () => {},
}

export default React.createContext(defaultInterfaceContext)
